import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';

export const apiInterceptorFn = (development: boolean): HttpInterceptorFn => {
  return (req: HttpRequest<any>, next: HttpHandlerFn) => {
    return next(req.clone({ url: buildApiUrl(req.url, development) }));
  };
};

/**
 * Applies the same URL rewrite `apiInterceptorFn` does, for callers that
 * bypass `HttpClient` (e.g. raw `fetch` / `fetchEventSource`) and
 * therefore never run through the interceptor chain.
 *
 * - dev: `/a/foo` → `/api/a/foo` (matches the dev proxy)
 * - prod: `/a/foo` → `https://<current-host>/a/foo`
 * - URLs already absolute, asset requests, and user uploads pass through
 *   unchanged.
 */
export function buildApiUrl(url: string, development: boolean): string {
  if (!shouldPrepend(url)) {
    return url;
  }
  return development ? prependApi(url) : prependHost(url);
}

function shouldPrepend(url: string) {
  return (
    url.match(/\.svg$/) == null && // Don't proxy svg asset requests
    url.match(/calltrk-user-uploads/) == null && // dont proxy user uploads
    url.match(/https?:\/\//) == null // dont proxy external urls
  );
}

function prependApi(url: string): string {
  // prepend / if its not already
  if (!url.match(/^\//)) {
    url = `/${url}`;
  }
  // prepend /api if its not already
  if (!url.match(/^\/api\//)) {
    url = `/api${url}`;
  }
  return url;
}

function prependHost(url: string): string {
  // prepend / if its not already
  if (!url.match(/^\//)) {
    url = `/${url}`;
  }
  return `${location.protocol}//${location.host}${url}`;
}
